import React from 'react';
import { caseStudies } from '../data/siteContent';

export default function SuccessStories() {
  return (
    <div className="bg-white min-h-screen py-20 px-6">
      <div className="max-w-5xl mx-auto space-y-8">
        <header className="text-center">
          <p className="text-xs uppercase tracking-[0.5em] text-gray-500">Case Studies</p>
          <h1 className="text-4xl font-bold text-charcoal">Proof points without revealing identities</h1>
        </header>

        <div className="space-y-6">
          {caseStudies.map((study) => (
            <article key={study.title} className="rounded-3xl border border-gray-200 bg-gray-warm/70 p-6 shadow-sm">
              <h2 className="text-2xl font-semibold text-charcoal">{study.title}</h2>
              <p className="text-gray-600 mt-3">{study.summary}</p>
              <p className="mt-4 text-sm font-semibold text-primary">Outcome: {study.outcome}</p>
            </article>
          ))}
        </div>

        <div className="text-center">
          <p className="text-sm text-gray-500">Need anonymized proof for your advisor partners?</p>
          <a
            href="/contact"
            className="mt-3 inline-flex items-center justify-center rounded-full border border-primary px-6 py-3 text-sm font-semibold text-primary"
          >
            Request the anonymized case library
          </a>
        </div>
      </div>
    </div>
  );
}
